import React, { memo } from 'react'
import { createStyles, makeStyles, Typography } from 'transfix-ui/core'
import { ShipperRateObject } from 'apps/marketplace/apiTypes/shipperRates'
import { brandColors, Table, TableBody } from 'transfix-ui'
import { ShipperRateHistoryTableHeader } from './ShipperRateHistoryTableHeader'
import { ShipperRateHistoryTableRow } from './ShipperRateHistoryTableRow'

interface IShipperRateHistoryTableProps {
  shipperRate: ShipperRateObject
  loading: boolean
}

const useShipperRateHistoryStyles = makeStyles(() =>
  createStyles({
    rateText: {
      color: brandColors.coolGray5,
      fontSize: 14,
    },
  })
)

export const ShipperRateHistoryTable = memo<IShipperRateHistoryTableProps>(
  ({ loading, shipperRate }) => {
    const getRatesToShow = (): ShipperRateObject[] => {
      if (shipperRate.previousRates) {
        return [shipperRate].concat(shipperRate.previousRates)
      }
      return [shipperRate]
    }

    const getNumberOfRatesText = (): String => {
      const numberOfRates = shipperRate.previousRates ? shipperRate.previousRates.length + 1 : 1
      return numberOfRates > 1 ? `${numberOfRates} rates` : `${numberOfRates} rate`
    }

    const classes = useShipperRateHistoryStyles()

    return (
      <>
        <p>
          <Typography variant='h3' className={classes.rateText}>
            Showing {getNumberOfRatesText()} for this contract
          </Typography>
        </p>
        <Table>
          <ShipperRateHistoryTableHeader />
          <>
            {!loading && (
              <TableBody>
                {getRatesToShow().map(shipperRate => (
                  <ShipperRateHistoryTableRow key={shipperRate.id} shipperRate={shipperRate} />
                ))}
              </TableBody>
            )}
          </>
        </Table>
      </>
    )
  }
)
